<button (click)="onClick()"
    [class]="isActive ? 'border-secondary-500 text-secondary-600' : 'border-transparent text-gray-500'"
    class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none focus:ring-0">
    {{tabName | titlecase }}
</button>